import { ResultBase, makeHttpRequest, POST } from "./api";

export enum ErrorCodes {}

export interface ResponseData {}

export interface Response extends ResultBase<ResponseData, ErrorCodes> {}

export const logout = async (): Promise<Response> => makeHttpRequest<{}, ResponseData, ErrorCodes>(POST, "logout", {});
